import { api } from './api';

export const fetchSkus = (params, options) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  return api.get(`/pricing/invoice_item_type`, payload, options);
};

export const fetchSkuById = (id, params) => {
  return api.get(`/pricing/invoice_item_type/${id}`, params);
};

export const fetchDeleteSku = (id, status = 'DELETED') => {
  return api.put(`/pricing/invoice_item_type/${id}`, {
    status,
  });
};

export const fetchCreateSku = (data) => {
  return api.post(`/pricing/invoice_item_type`, data);
};

export const fetchUpdateSku = (id, data) => {
  return api.put(`/pricing/invoice_item_type/${id}`, data);
};

export const fetchAssociatedTaxRuleset = (id, params) => {
  return api.get(`/pricing/invoice_item_type/${id}/tax_rules_sets`, params);
};
